import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { setMonthlyFlex } from 'actions/expiryRenewalActions';
import { dispatch } from 'store';
import { Store } from 'types/store';
import { EUROPEAN_RESCUE_PRODUCT_CODE } from '../../utils/pricingUtils';
import { hasEuropeanRescue, holdsEuropeanRescue, keepAnnual, goMonthly } from '../../utils/europeanRescueMonthlyFlex';
import EuropeanRescueMonthlyFlexModal from './EuropeanRescueMonthlyFlexModal';

const FlexToggle = () => {
  const { addOns, monthlyFlex, pageModel } = useSelector((state: Store) => state?.expiryRenewal);
  // Whether the "can't have both" conflict modal is currently open.
  const [showEurRescueModal, setShowEurRescueModal] = useState(false);

  const isMonthly = pageModel?.isMonthlyLongerTermPolicy;
  /**
   * A member who already holds European Rescue is offered Monthly Flex by the backend but
   * can never take it, so the offer is withdrawn here rather than presented and then
   * refused. Deliberately independent of whether they have dropped European Rescue on this
   * step - removing it does not buy them monthly payment.
   */
  const isMonthlyFlex = pageModel?.isEligibleForMonthlyFlex && !holdsEuropeanRescue(pageModel);

  // Default button style where toggle not available
  const defaultClass = !isMonthlyFlex && 'btn-secondary text-white';

  // Toggle switch button style
  const activeClass = 'btn-secondary text-white';

  // If European Rescue is selected, ask the user to choose instead of switching straight to monthly.
  const handleSwitchToMonthly = () => {
    if (!isMonthlyFlex) return;

    if (hasEuropeanRescue(addOns.selected)) {
      setShowEurRescueModal(true);
      return;
    }

    dispatch(setMonthlyFlex(true));
  };

  return (
    <div className="position-absolute top-0 end-0 p-3">
      <div className="btn-group" role="group" aria-label="plan">
        {(isMonthly || isMonthlyFlex) && (
          <button
            className={`btn btn-outline-dark ${((isMonthly || monthlyFlex) && activeClass) || defaultClass} btn-sm fw-bold px-3`}
            onClick={handleSwitchToMonthly}
            type="button"
          >
            Monthly
          </button>
        )}
        {(!isMonthly || isMonthlyFlex) && (
          <button
            className={`btn btn-outline-dark ${(!monthlyFlex && activeClass) || defaultClass} btn-sm fw-bold px-3`}
            onClick={() => isMonthlyFlex && dispatch(setMonthlyFlex(false))}
            type="button"
          >
            Annual
          </button>
        )}
      </div>
      {showEurRescueModal && (
        <EuropeanRescueMonthlyFlexModal
          onDismiss={() => setShowEurRescueModal(false)}
          onKeepAnnual={() => {
            keepAnnual(addOns.selected);
            setShowEurRescueModal(false);
          }}
          onGoMonthly={() => {
            goMonthly(addOns.selected.filter(({ productCode }) => productCode !== EUROPEAN_RESCUE_PRODUCT_CODE));
            setShowEurRescueModal(false);
          }}
        />
      )}
    </div>
  );
};

export default FlexToggle;
